import { axios, BaseApiUrl } from '../axios_config';


// PDA-2.换标操作查询列表数据
export const getLabelChangeListData = params =>{
    return axios.post(`${BaseApiUrl}/ChangeLabel/GetLabelChangeListData`, { ...params }).then(res => res.data);
}

export const getLabelChangeSkuStorage = params =>{
    return axios.post(`${BaseApiUrl}/ChangeLabel/GetLabelChangeSkuStorage`, { ...params }).then(res => res.data);
}


// 校验库位信息 校验库位对应的SKU有无库存
export const LablechangeCheckStorageAndStock = params =>{
    return axios.post(`${BaseApiUrl}/ChangeLabel/LablechangeCheckStorageAndStock`, {...params}).then(res => res.data);
}

// 执行完成
export const LabelChangeFinishSubmit = params =>{
    return axios.post(`${BaseApiUrl}/ChangeLabel/LabelChangeFinishSubmit`, { ...params }).then(res => res.data);
}

// 执行完成
export const LabelChangeRefuseSubmit = params =>{
    return axios.post(`${BaseApiUrl}/ChangeLabel/LabelChangeRefuseSubmit`, { ...params }).then(res => res.data);
}


// 执行完成
export const ChangelabelPrintSku = params =>{
    return axios.post(`${BaseApiUrl}/ChangeLabel/ChangelabelPrintSku`, [ ...params ]).then(res => res.data);
}

// 提交换库位操作
export const InventoryChangeFinishSubmit = params =>{
    return axios.post(`${BaseApiUrl}/ChangeLabel/InventoryChangeFinishSubmitAsync`, { ...params }).then(res => res.data);
}



